import { useEffect, useState } from 'react';
import axios from 'axios';
import vopayApi from '@/services/api.config';
import useDataFetchIndicator from '../useDataFetchIndicator';
import { GenerateGCMEmbedUrlRequest } from 'vopay';
const { api } = vopayApi;

export default function useGenerateGCMEmbedUrl() {
  const source = axios.CancelToken.source();
  const [link, setLink] = useState<string>();
  const [, setDataFetchingInfo] = useDataFetchIndicator();

  useEffect(() => {
    return () => {
      source.cancel();
    };
  }, []);

  async function generateGCMUrl(requestParams: GenerateGCMEmbedUrlRequest) {
    try {
      setDataFetchingInfo(true);

      const res = await api.generateGCMEmbedUrl(requestParams, source);
      setLink(res.Link);
      return res;
    } finally {
      setDataFetchingInfo(false);
    }
  }

  return {
    link,
    generateGCMUrl,
  };
}
